import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-[#f1f1f1] py-8 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16">
          {/* Company Information */}
          <div className="space-y-1">
            <div className="text-base font-bold text-[#666666] font-body mb-2">
              Watson Aero
            </div>
            <div className="text-[#666666] font-body text-sm leading-relaxed">
              1266 Byron Burt Road<br />
              Louisville, GA 30434
            </div>
            <div className="text-[#666666] font-body text-sm leading-relaxed mt-3">
              Located at the Louisville Municipal Airport (2J3), just 40 miles from
              Augusta, GA, home of the Masters Tournament at the Augusta National
            </div>
          </div>

          {/* Social Media & Copyright */}
          <div className="text-right space-y-4">
            {/* Social Media Icons */}
            <div className="flex justify-end space-x-1">
              <a
                href="https://www.facebook.com/watsonaero/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 bg-[#656565] rounded-sm flex items-center justify-center hover:bg-[#555555] transition-colors"
                aria-label="Facebook"
              >
                <span className="text-white text-xs font-bold">f</span>
              </a>
              <a
                href="mailto:james@watsonaero.com"
                className="w-8 h-8 bg-[#656565] rounded-sm flex items-center justify-center hover:bg-[#555555] transition-colors"
                aria-label="Email"
              >
                <span className="text-white text-xs font-bold">@</span>
              </a>
              <a
                href="https://plus.google.com/106707404738928165597"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 bg-[#656565] rounded-sm flex items-center justify-center hover:bg-[#555555] transition-colors"
                aria-label="Google Plus"
              >
                <span className="text-white text-xs font-bold">G+</span>
              </a>
            </div>

            {/* Copyright Information */}
            <div className="text-xs text-[#b0b0b0] space-y-1 leading-relaxed">
              <div>© COPYRIGHT 2026. ALL RIGHTS RESERVED.</div>
              <div>
                Header Photo: © Copyright{' '}
                <a
                  href="https://www.flickr.com/photos/56785346@N00/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#b0b0b0] hover:text-[#666666] underline"
                >
                  Mário Simoes
                </a>{' '}
                and licensed for reuse under this{' '}
                <a
                  href="http://creativecommons.org/licenses/by-sa/2.0/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#b0b0b0] hover:text-[#666666] underline"
                >
                  Creative Commons Licence
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};